// extracted by mini-css-extract-plugin
module.exports = {"connected":"connected-module--connected--6V95q","dialog":"connected-module--dialog--2k1bg"};